import React, { useState } from "react";
import classes from "./VesterWithdrawModalStyles.module.scss";
import { ethers } from "ethers";
import Vester from "../../../abis/Vester.json";
import { callContract } from "../../../lib/contracts";
import { t, Trans } from "@lingui/macro";
import { ActionButton } from "../../Buttons/ActionButton/ActionButton";
import { ModalBase } from "../ModalBase/ModalBase";
import { useWeb3React } from "@web3-react/core";
import { useChainId } from "../../../lib/chains";

type Props = {
  onClose: () => void;
  title: string;
  vesterAddress: string;
  setPendingTxns: any;
};
export const VesterWithdrawModal = ({ onClose, title, vesterAddress, setPendingTxns }: Props) => {
  const { library } = useWeb3React();
  const { chainId } = useChainId();

  const [isWithdrawing, setIsWithdrawing] = useState(false);

  const onClickPrimary = () => {
    setIsWithdrawing(true);
    const contract = new ethers.Contract(vesterAddress, Vester.abi, library.getSigner());

    callContract(chainId, contract, "withdraw", [], {
      sentMsg: t`Withdraw submitted.`,
      failMsg: t`Withdraw failed.`,
      successMsg: t`Withdrawn!`,
      setPendingTxns,
    })
      .then(async (res) => {
        onClose();
      })
      .finally(() => {
        setIsWithdrawing(false);
      });
  };

  return (
    <ModalBase title={title} onClose={onClose}>
      <div className={classes.wrapper}>
        <div className={classes.notes}>
          <span className={classes.note}>
            <Trans>This will withdraw and unreserve all tokens as well as pause vesting.</Trans>
          </span>
          <span className={classes.note}>
            <Trans>esCAD tokens that have been converted to CAD will remain as CAD tokens.</Trans>
          </span>

          <span className={classes.note}>
            <Trans>
              To claim CAD tokens without withdrawing, use the "Claim" button under the Total Rewards section.
            </Trans>
          </span>
        </div>

        <ActionButton
          onClick={onClickPrimary}
          type={"outlined"}
          buttonText={isWithdrawing ? "Confirming..." : "Confirm Withdraw"}
          disabled={isWithdrawing}
          className={classes.button}
        />
      </div>
    </ModalBase>
  );
};
